/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import axios from 'axios';
import { commonConstants } from '../constants';
import { postRequest } from '../helpers/apiUtils';

export const projectService = {
  getRole,
  getMultiRole,
  getAnnouncements,
  getSoftwareReleases,
  getGlobalMapping,
  getGlobalMapping_enc,
  handlePostRequest,
  getCommandStatus,
  gitBranchRefresher,
  getCreatePlanPermission,
  getUserCpaList,
};

async function getUserCpaList(item) {
  let data = {
    body: item,
  };
  const res = await postRequest(
    commonConstants.PLAN_SPONSERS_API,
    '/cpa/get-cpa-list-v1-enc',
    data
  );
  return res;
}

async function getCreatePlanPermission(item) {
  let data = {
    body: item,
  };
  let res = await postRequest(
    commonConstants.PLAN_SPONSERS_API,
    '/cpa/get-create-plan-permission',
    data
  );
  return res;
}

async function handlePostRequest(data) {
  try {
    await axios.post(
      'https://oujxa8n4dl.execute-api.us-east-1.amazonaws.com/develop/git_repo_cloner',
      data
    );
    // console.log('Response:', response.data);
  } catch {
    // console.error('Error:', error);
  }
}

async function getCommandStatus() {
  try {
    // const response = await axios.get(`https://oujxa8n4dl.execute-api.us-east-1.amazonaws.com/develop/get_command_status?command_id=${id}`);
    const response = await axios.get(
      `https://oujxa8n4dl.execute-api.us-east-1.amazonaws.com/develop/get_command_status?command_id=16aa4bfe-6bde-4c67-96e5-f9afa72ca137`
    );
    console.log('Response:', response);
    return response;
  } catch {
    return null;
    // console.error('Error:', error);
  }
}

function getGlobalMapping(queryData) {
  let data = { body: queryData };
  return postRequest(
    commonConstants.PLAN_LEVEL_UTILS_API,
    '/plan-details/get-global-mapping',
    data
  );
}

function getGlobalMapping_enc(queryData) {
  let data = { body: queryData };
  return postRequest(
    commonConstants.PLAN_LEVEL_UTILS_API,
    '/plan-details/get-global-mapping-enc',
    data
  );
}

async function getRole(item) {
  let data = {
    body: item,
  };
  let res = await postRequest(commonConstants.PLAN_SPONSERS_API, '/cpa/get-role-enc', data);
  return res;
}

async function getMultiRole(body) {
  let res = await postRequest(commonConstants.PLAN_SPONSERS_API, '/cpa/get-multi-role-enc', {
    body,
  });
  return res;
}

function getAnnouncements(body) {
  let data = {
    body,
  };
  return postRequest(commonConstants.BROADCAST_API, 'get-announcements', data);
}

async function gitBranchRefresher(data) {
  let res = axios.post(
    'https://oujxa8n4dl.execute-api.us-east-1.amazonaws.com/develop/git_branch_refresher',
    data
  );
  return res;
}

function getSoftwareReleases(body) {
  let data = {
    body,
  };
  return postRequest(commonConstants.BROADCAST_API, 'get-software-releases', data);
}
